<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :title="status?'查看权限':'编辑权限'"
      :visible.sync="editDialogVisible"
      width="30%"
      :close-on-click-modal='false'
      :before-close="closeEditDialog">
      <el-form label-width="110px" ref="ruleForm"  :rules="rules" :model="form" :disabled="status">
        <el-form-item label="权限名称" prop="accessName">
          <el-input v-model.trim="form.accessName" autocomplete="off" placeholder="请输入权限名"></el-input>
        </el-form-item>
        <el-form-item label="权限标志" prop="accessValue">
          <el-input v-model.trim="form.accessValue" autocomplete="off" placeholder="请输入权限标志"></el-input>
        </el-form-item>
        <el-form-item label="权限路径" prop="accessUrl">
          <el-input v-model.trim="form.accessUrl" autocomplete="off" placeholder="请输入权限路径"></el-input>
        </el-form-item>
        <el-form-item label="请求方式" prop="requestMethod">
          <el-select v-model="form.requestMethod" style="width:100%" :clearable="clearable">
            <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" autocomplete="off" :rows="5" maxlength="100" show-word-limit placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="status===false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { accessForId, editAccess } from '@/api/permissionManager'
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        accessUrl: ''
      },
      rules: {
        accessName: [
          { required: true, message: '请输入权限名', trigger: 'blur' }
        ],
        /* accessUrl: [
          { required: true, message: '请输入权限路径', trigger: 'change' }
        ], */
        accessValue: [
          { required: true, message: '请输入权限标志', trigger: 'change' }
        ]
      },
      options: [
        {
          id: 0,
          name: 'GET'
        },
        {
          id: 1,
          name: 'HEAD'
        },
        {
          id: 2,
          name: 'POST'
        },
        {
          id: 3,
          name: 'PUT'
        },
        {
          id: 4,
          name: 'PATCH'
        },
        {
          id: 5,
          name: 'DELETE'
        },
        {
          id: 6,
          name: 'OPTIONS'
        },
        {
          id: 7,
          name: 'TRACE'
        }
      ],
      clearable: true
    }
  },
  created () {
    this.getAccessForId()
  },
  watch: {
    'form.accessUrl': {
      handler (val) {
        console.log(val)
        if (val !== '' && val !== '---') {
          // this.form.requestMethod = ''
          this.clearable = false
        } else {
          this.clearable = true
        }
      },
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    getAccessForId () {
      accessForId(this.editData.accessId).then((res) => {
        const resData = res.data.data
        if (resData.accessUrl === '' || JSON.stringify(resData.accessUrl) === 'null') resData.accessUrl = '---'
        if (resData.accessValue === '' || JSON.stringify(resData.accessValue) === 'null') resData.accessValue = '---'
        this.form = Object.assign({}, resData)
        console.log(this.form)
      })
    },
    closeEditDialog () {
      this.$emit('closeEditDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          editAccess(this.form).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.$emit('closeEditDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
